import React, { useEffect, useState } from 'react';
import { Animated } from 'react-native';
import { hasNotchOrDynamicIsland } from 'utils/deviceUtils';
import ModalStackHeader, {
  ModalStackHeaderCustomProps as StackHeaderCustomProps,
} from './ModalStackHeader';
import StackHeader from './StackHeader';

export const ModalHeaderComponent = (props: StackHeaderCustomProps) => (
  <ModalStackHeader {...props} />
);

export const StackHeaderComponent = (props: StackHeaderCustomProps) => (
  <StackHeader stack="park" {...props} />
);

export const StackHeaderComponentNoHeaderBack = (
  props: StackHeaderCustomProps
) => <StackHeader {...props} stack="park" headerBackIconVisible={false} />;

export const StackHeaderComponentTitleSmall = (
  props: StackHeaderCustomProps
) => {
  return (
    <StackHeader
      {...props}
      stack="park"
      useInsetForTop
      titleSize="small"
      extraPadding={['horizontal', 'top']}
      extraPaddingValue={hasNotchOrDynamicIsland() ? { top: 10 } : undefined}
    />
  );
};

export const CardOverlay = ({
  style,
  visibleOpacity = 0.6,
  backgroundColor = 'black',
  useLibraryFadeAnimations = true,
  animationDuration = 300,
}: {
  // style: Animated.WithAnimatedValue<StyleProp<ViewStyle>>; //This is the correct type, but conflicts with the opacity prop somehow
  style: any;
  visibleOpacity?: number;
  useLibraryFadeAnimations?: boolean;
  animationDuration?: number;
  backgroundColor?: string;
}) => {
  const [customOpacity] = useState(() => new Animated.Value(0));

  useEffect(() => {
    if (!useLibraryFadeAnimations) {
      Animated.timing(customOpacity, {
        toValue: visibleOpacity,
        duration: animationDuration,
        useNativeDriver: true,
      }).start();
    }

    return () => customOpacity.stopAnimation();
  }, [
    animationDuration,
    customOpacity,
    useLibraryFadeAnimations,
    visibleOpacity,
  ]);

  const renderStyle = {
    backgroundColor: backgroundColor,
    flex: 1,
    opacity: useLibraryFadeAnimations ? style?.opacity : customOpacity,
  };

  return <Animated.View style={renderStyle} />;
};

export const cardOverlayCallback = (props: any) => (
  <CardOverlay {...props} useLibraryFadeAnimations={true} />
);
